import Instance from "../../../../Axios";

// New Actions for the app

const GetAllWorkPermits = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_ALL_WORK_PERMITS", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllWorkPermits;
